export default __webpack_public_path__ + "static/media/motivation.dc3c848f.svg";